<template>
  <header class="header">
    <div class="wrapper flex">
      <div class="left">
        <router-link to="/" class="logo flex">
          <img src="./../img/logo.svg" class="img" />
          <div class="title">IdeasGen</div>
        </router-link>
      </div>
      <div class="center">
        <div class="nav">
          <div class="nav__item">
            <router-link to="/home" class="desc semibold">{{
              $t(`Home`)
            }}</router-link>
          </div>
          <div class="nav__item">
            <router-link to="/product-list" class="desc semibold">{{
              $t(`Prompts`)
            }}</router-link>
          </div>
          <!-- <div class="nav__item">
            <div
              @click="scrollToSection('howItWorks')"
              class="desc semibold hover-link"
            >
              {{ $t(`How it works?`) }}
            </div>
          </div>
          <div class="nav__item">
            <div
              @click="scrollToSection('cases')"
              class="desc semibold hover-link"
            >
              {{ $t(`Cases`) }}
            </div>
          </div> -->
          <div class="nav__item">
            <router-link to="/contacts" class="desc semibold">{{
              $t(`Contacts`)
            }}</router-link>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="select-list">
          <div
            class="currency-select-container cart"
            v-if="curr && currOptions && currOptions.length > 1"
          >
            <select class="select currency-select" v-model="curr">
              <option
                :value="item.id"
                v-for="item in currOptions"
                :key="item.id"
              >
                {{ item.text }}
              </option>
            </select>
          </div>
          <LanguageSelectDropdown />
        </div>

        <router-link
          to="/profile/contact-info"
          class="desc link-container dropdown-open"
          v-if="isAuth"
        >
          <span>{{ $t(`My account`) }}</span>
        </router-link>
        <div class="link-container" v-if="!isAuth">
          <button class="button" @click="$emit('openSignUpModal')">
            {{ $t(`Join now`) }}
          </button>
          <button class="button white" @click="$emit('openSignInModal')">
            {{ $t(`Sign in`) }}
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { defineComponent } from 'vue';

import { mapGetters, mapActions } from "vuex";
import LanguageSelectDropdown from "@/components/LanguageSelectDropdown.vue";

export default defineComponent({
  emits: [
    'openSignUpModal',
    'openSignInModal',
    'logout',
    'searchSubmit',
    'scrollToSection',
  ],

  name: "Header",

  components: {
    LanguageSelectDropdown,
  },

  computed: {
    ...mapGetters("app", ["currency", "allCurrencies"]),
    ...mapGetters("user", ["isAuth"]),

    curr: {
      get() {
        return this.currency;
      },
      set(value) {
        this.changeCurrency(value);
      },
    },

    currOptions() {
      return this.allCurrencies;
    },
  },

  methods: {
    ...mapActions("app", ["changeCurrency"]),
    openSignInModal() {
      this.$emit("openSignInModal");
    },
    openSignUpModal() {
      this.$emit("openSignUpModal");
    },
    logout() {
      this.$emit("logout");
    },
    searchSubmit() {
      this.$emit("searchSubmit", this.search);
    },
    onEnter() {
      this.searchSubmit();
    },
    scrollToSection(section) {
      this.$emit("scrollToSection", section);
    },
  },

  mounted() {},
});
</script>
